import { render, staticRenderFns } from "./NotificationCommentUpdate.vue?vue&type=template&id=d1ae2952&scoped=true&lang=pug&"
import script from "./NotificationCommentUpdate.vue?vue&type=script&lang=js&"
export * from "./NotificationCommentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ae2952",
  null
  
)

export default component.exports